<ng-container *ngIf="configBloque?.bloque_activo">
  <div class="fondo-banner-app">
    <div class="mobile">
      <img src="{{ configBloque?.img_icono }}" alt="Mobile App" />
    </div>
    <div class="app-links-texto">
      <h1>{{ configBloque?.texto_uno }}</h1>
      <p>{{ configBloque?.texto_dos }}</p>
      <div class="app-links">
        <a href="{{ configBloque?.url_android }}" target="_blank">
          <img src="{{ configBloque?.img_android }}" alt="Android" />
        </a>
        <a href="{{ configBloque?.url_ios }}" target="_blank">
          <img src="{{ configBloque?.img_ios }}" alt="iOS" />
        </a>
      </div>
    </div>
  </div>

  <div class="contenedor-principal" *ngIf="mostrarBannerCookies">
    <div class="fondo-banner-app-mv" [style.border-color]="configBloque?.color_borde">
      <span class="cerrar" [style.color]="configBloque?.color_btn_cierre" (click)="close()">X</span>
      <div class="textos-mv">
        <h1 [style.color]="configBloque?.color_texto_uno">{{ configBloque?.texto_uno }}</h1>
        <p [style.color]="configBloque?.color_texto_dos">{{ configBloque?.texto_dos }}</p>
      </div>
      <div class="container-img">
        <div class="mobile-mv">
          <img src="{{ configBloque?.img_icono }}" alt="Mobile App" />
        </div>
        <div class="app-links-mv">
          <a href="{{ configBloque?.url_android }}" target="_blank">
            <img src="{{ configBloque?.img_android }}" alt="Android" />
          </a>
          <a href="{{ configBloque?.url_ios }}" target="_blank">
            <img src="{{ configBloque?.img_ios }}" alt="iOS" />
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-container>
